<button mat-stroked-button color="primary" type="button" (click)="saveToDirectory()">
  <mat-icon>save_alt</mat-icon>
  {{ 'dataManagement.dataExchangeRequests.actions.saveToDirectory' | transloco }}
</button>
